import { Dispatch, SetStateAction } from 'react';
import { ISearchFilter } from '@models/dto/searchCriteria.dto';
import { FilterCriteriaFields } from '@models/filter-criteria-fields';

export const appendSearchFilter = (
  field: FilterCriteriaFields,
  value: string,
  searchFilterItem: ISearchFilter[],
  setSearchFilterItem: Dispatch<SetStateAction<ISearchFilter[]>>,
): void => {
  const existed = searchFilterItem?.some((item) => item.field === field);

  if (!existed) setSearchFilterItem([...searchFilterItem, { field, value }]);
  if (value === '')
    setSearchFilterItem((prevValue) =>
      prevValue.filter((item) => item.field !== field),
    );
  else
    setSearchFilterItem((prevValue) =>
      prevValue.map((item) => (item.field === field ? { field, value } : item)),
    );
};
